const shipmentSizes = ["S", "M", "L"] as const;
type ShipmentSize = typeof shipmentSizes[number];

export { shipmentSizes };
export type { ShipmentSize };
